import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import './init-sentry';
import App from './app';
import {FONT_ICON_URL} from "./constants/api-url.ts";
import {appStore} from "./store/app-store.ts";

const environment = import.meta.env.VITE_ENV_NAME;
const isProduction = environment  === 'production';

window.__DEBUG__ = {
    store: appStore,
    logState: () => {
        console.group('🐛 App Store State');
        console.log('Status:', appStore.status);
        console.log('Locale:', appStore.locale);
        console.log('isTranslationsLoading:', appStore.isTranslationsLoading);
        console.log('isPaired:', appStore.isPaired);
        console.log('Context:', appStore.context);
        console.log('Messages count:', Object.keys(appStore.messages || {}).length);
        console.log('Report:', appStore.report);
        console.log('Pairing Info:', appStore.pairingInformation);
        console.groupEnd();
    },
    logMessages: () => {
        console.log('Translation Messages:', appStore.messages);
    },
    logContext: () => {
        console.log('Context:', appStore.context);
    }
};

console.log('Debug utilities available at window.__DEBUG__');
console.log('   - window.__DEBUG__.store (access the store directly)');
console.log('   - window.__DEBUG__.logState() (log current state)');
console.log('   - window.__DEBUG__.logMessages() (log translations)');
console.log('   - window.__DEBUG__.logContext() (log context)');

const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = FONT_ICON_URL;
document.head.appendChild(link);

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App/>
        {!isProduction && <div className="env-banner">{environment}</div>}
    </StrictMode>,
);
